<script>
  import MiniLogo from "./Misc/MiniLogo.svelte";
  import { auth } from "./firebase";
  import { createEventDispatcher } from "svelte";

  export let user;
  export let page;

  const dispatch = createEventDispatcher();

  function calc() {
    dispatch("calc");
  }

  function profile() {
    dispatch("profile");
  }

  function logout() {
    auth.signOut();
    localStorage.removeItem('user');
  }

  function admin() {
    dispatch("admin");
  }
</script>

<style>
  .link:hover {
    cursor: pointer;
    text-decoration: underline;
  }

</style>

<div
  class="d-flex flex-column flex-md-row align-items-center p-3 px-md-4 mb-3
  bg-white border-bottom box-shadow">
  <MiniLogo />
  <h5 class="my-0 mr-md-auto" style="color: #1a2b6d">
    Closing Cost Help
  </h5>
  <nav class="my-2 my-md-0 mr-md-3">
    {#if user.isAdmin === true}
      <span class="link p-2 text-dark" on:click={admin}>Admin</span>
    {/if}
    <span class="link p-2 text-dark" on:click={calc}>Calculator</span>
    <span class="link p-2 text-dark" on:click={profile}>{user.firstName} {user.lastName}</span>
  </nav>
  <button class="btn btn-outline-primary" on:click={logout}>
    Logout
  </button>
</div>
